(function() {
    'use strict';

    angular.module('conferencesApp').controller('AdminConferenceSpeakersCtrl', function($scope, Speaker) {

        $scope.speakers = Speaker.query({conference: $scope.conferenceId});

    });

    angular.module('conferencesApp').controller('AdminConferenceSpeakerCreateCtrl', function($scope, $state, $stateParams, $q, Upload, WORLDSKILLS_API_IMAGES, WSAlert, Speaker) {

        var photo = $q.when();

        if ($stateParams.sessionId) {
            $scope.sessionId = $stateParams.sessionId;
        }

        $scope.speaker = new Speaker();
        $scope.speaker.conference = $scope.conference;
        $scope.speaker.bio = {text: '', lang_code: 'en'};

        $scope.onFileSelect = function($files) {
            var deferred = $q.defer();
            photo = deferred.promise;
            $scope.upload = Upload.upload({
                url: WORLDSKILLS_API_IMAGES,
                file: $files[0],
            }).success(function(data, status, headers, config) {
                deferred.resolve(data);
            });
        };

        $scope.save = function() {
            $scope.submitted = true;
            photo.then(function (photo) {
                if (!$scope.form.$invalid) {
                    $scope.loading = true;
                    if (typeof photo != 'undefined') {
                        $scope.speaker.photo = {id: photo.id, thumbnail_hash: photo.thumbnail_hash};
                    }
                    $scope.speaker.$save(function () {
                        if ($scope.sessionId) {
                            WSAlert.success('The speaker has been added to the Conference.');
                            $state.go('admin_conferences.conference.session.speakers', {sessionId: $scope.sessionId});
                        } else {
                            WSAlert.success('The speaker has been added successfully.');
                            $state.go('admin_conferences.conference.detail.speakers');
                        }
                    });
                }
            });
        };
    });

    angular.module('conferencesApp').controller('AdminConferenceSpeakerCtrl', function($scope, $state, $stateParams, $q, Upload, WORLDSKILLS_API_IMAGES, WSAlert, Speaker) {

        var photo = $q.when();

        $scope.id = $stateParams.speakerId;

        $scope.speaker = Speaker.get({conference: $scope.conferenceId, id: $scope.id}, function () {
            if (!$scope.speaker.bio) {
                $scope.speaker.bio = {text: '', lang_code: 'en'};
            }
            $scope.speakerTitle = $scope.speaker.first_name + ' ' + $scope.speaker.last_name;
        });

        $scope.onFileSelect = function($files) {
            var deferred = $q.defer();
            photo = deferred.promise;
            $scope.upload = Upload.upload({
                url: WORLDSKILLS_API_IMAGES,
                file: $files[0],
            }).success(function(data, status, headers, config) {
                deferred.resolve(data);
            });
        };

        $scope.save = function() {
            $scope.submitted = true;
            photo.then(function (photo) {
                if (!$scope.form.$invalid) {
                    $scope.loading = true;
                    if (typeof photo != 'undefined') {
                        $scope.speaker.photo = {id: photo.id, thumbnail_hash: photo.thumbnail_hash};
                    }
                    $scope.speaker.$update(function () {
                        WSAlert.success('The speaker has been updated successfully.');
                        $state.go('admin_conferences.conference.detail.speakers');
                    });
                }
            });
        };

        $scope.deleteSpeaker = function() {
           if (confirm('Deleting the Speaker will also delete his biography and will likely break links on the website. Click OK to proceed.')) {
               $scope.deleteLoading = true;
               $scope.speaker.$delete(function () {
                   WSAlert.success('The speaker has been deleted successfully.');
                   $state.go('admin_conferences.conference.detail.speakers');
               });
           }
        };
    });
})();
